import { useRef } from 'react';
import Layout from '@/components/feature/Layout';
import useDocumentMeta from '@/hooks/useDocumentMeta';
import useEditorialReveal from '@/hooks/useEditorialReveal';
import { contactHeroImage } from '@/mocks/site';
import EstimateForm from './components/EstimateForm';

export default function ContactPage() {
  useDocumentMeta(
    'Contact | Request an Exterior Wall Estimate | MATERA',
    'Request an estimate from MATERA for exterior wall restoration, render and stucco finishes or mineral coatings. Tell us about your facade and we will reply with next steps.',
  );
  const heading = useRef<HTMLDivElement>(null);
  useEditorialReveal(heading);
  return (
    <Layout>
      <section className="relative mt-16 w-full min-h-[440px] md:min-h-[480px] md:h-[58vh] flex items-end overflow-hidden bg-background-200">
        <img
          src={contactHeroImage}
          width={1920}
          height={1080}
          decoding="async"
          alt="Precisely finished warm mineral-render exterior wall in directional sunlight"
          title="MATERA mineral render exterior wall"
          fetchPriority="high"
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/45 via-black/20 to-transparent" aria-hidden="true" />
        <div className="relative w-full shell py-14 md:py-20 text-background-50">
          <div className="grid grid-cols-1 lg:grid-cols-12">
            <div ref={heading} className="lg:col-span-7">
              <p className="text-[11px] uppercase tracking-[0.2em] opacity-90">04 / Request an estimate</p>
              <h1 data-reveal="title" className="mt-6 font-heading font-medium leading-[1.04] tracking-[-0.02em] text-[clamp(2.4rem,5vw,4.5rem)]">
                Let&apos;s talk about your walls.
              </h1>
              <p className="mt-6 max-w-md text-[15px] leading-relaxed opacity-90">
                Tell us about your surface, its current condition, and the finish you have in mind. We&apos;ll discuss the next steps together.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-background-50 py-16 md:py-24">
        <div className="shell grid grid-cols-1 lg:grid-cols-12">
          <div className="w-full lg:col-span-10 lg:col-start-2 max-w-5xl mx-auto">
            <EstimateForm />
          </div>
        </div>
      </section>
    </Layout>
  );
}